import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ControlContainer, FormArray, FormBuilder, FormGroup, FormGroupDirective, FormGroupName, Validators } from '@angular/forms';
import { UserDetailsService } from 'src/app/service/user-details.service';

@Component({
  selector: 'app-reporting-member-dtls',
  templateUrl: './reporting-member-dtls.component.html',
  styleUrls: ['./reporting-member-dtls.component.css'],
  viewProviders: [{
    provide: ControlContainer, useExisting: FormGroupDirective
  }]
})
export class ReportingMemberDtlsComponent implements OnInit, OnChanges {

  user: any = {};

  @Input()
  repMemData: any;

  @Input()
  action: string;

  constructor(private userDetailsService: UserDetailsService,
    private fb: FormBuilder,
    private fgd: FormGroupDirective,
    private cdref: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.user = this.userDetailsService.getUserDetails() || {};
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.user = this.userDetailsService.getUserDetails() || {};
    this.fgd.form.addControl('reportingMemName', this.fb.control(this.repMemData?.reportingMemName || this.user.userName, [Validators.required]));
    this.fgd.form.addControl('reportingMemId', this.fb.control(this.repMemData?.reportingMemId || this.user.entityCode, [Validators.required]));
    this.cdref.detectChanges();
  }
}
